import { observable, action } from 'mobx';
import _ from 'lodash';
import axios from 'axios';
import $ from 'jquery';
import {
  getItemFromLocalStorage,
  setItemLocalStorage,
} from './storage/storage';
import ValidationData from './validation/ValidationStore';

const oneYear = 1;
const fiveYears = 5;
const tenYears = 10;
const fifteenYears = 15;
const twentyYears = 20;
const thirtyYears = 30;

const allFixedRateTerms = [
  oneYear,
  fiveYears,
  tenYears,
  fifteenYears,
  twentyYears,
  thirtyYears];

class CalculationFormStore {
  @observable accessor chfLtv = '';
  @observable accessor overviewInterestsErrorMessage;
  @observable accessor errorMessage;
  @observable accessor labelInterests = getItemFromLocalStorage('LooptijdRenteLabelInterests') || [];

  @observable accessor form = {
    mortgage: 270000,
    personalDeposit: 0,
    nhg: 0,
  };

  constructor() {
    this.setForm = this.setForm.bind(this);
    this.toggleNHG = this.toggleNHG.bind(this);
    this.setBaseFormData = this.setBaseFormData.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.getChfLtv = this.getChfLtv.bind(this);
    this.getInterestForFrt = this.getInterestForFrt.bind(this);
    this.equalizeLabelInterests = this.equalizeLabelInterests.bind(this);
    this.addNewLabelInterests = this.addNewLabelInterests.bind(this);
    this.getInterestAndSortTable = this.getInterestAndSortTable.bind(this);
  }

  @action
  async getChfLtv() {
    const chfLtv = await axios('/regulations/chf-ltv');

    if (_.has(chfLtv, 'data')) {
      this.chfLtv = chfLtv.data;
    }
  }

  @action getInterestAndSortTable(cb) {
    Promise.all([
      this.getInterestForFrt(twentyYears),
      this.getInterestForFrt(oneYear),
      this.getInterestForFrt(fiveYears),
      this.getInterestForFrt(tenYears),
      this.getInterestForFrt(fifteenYears),
      this.getInterestForFrt(thirtyYears),
    ])
    .then((res) => {
      /* Equalize after first request to overview/interest */
      this.labelInterests = [];
      this.labelInterests = this.equalizeLabelInterests(res[0]);
      this.labelInterests = this.addNewLabelInterests(this.labelInterests, res[1]);
      this.labelInterests = this.addNewLabelInterests(this.labelInterests, res[2]);
      this.labelInterests = this.addNewLabelInterests(this.labelInterests, res[3]);
      this.labelInterests = this.addNewLabelInterests(this.labelInterests, res[4]);
      this.labelInterests = this.addNewLabelInterests(this.labelInterests, res[5]);
      cb();
    });
  }

  /* Get interest for one frt */
  @action
  // eslint-disable-next-line consistent-return
  async getInterestForFrt(frtForRequest) {
    /* When api is ready for receiving post requests, add postData */
    const getData = this.setBaseFormData();

    if (!_.isEmpty(getData)) {
      const res = await axios.get(`/overview/interest?${$.param(getData)}&frt=${frtForRequest
        }`)
        .then((response) => {
          this.overviewInterestsErrorMessage = '';
          if (response.data.length === 0) {
            this.overviewInterestsErrorMessage = 'Er zijn geen rentes gevonden.';
          }
          return response.data;
        })
        .catch(err => this.errorMessage = err);

      return res;
    }
  }

  /* Helper method for getInterestForFrt */
  @action equalizeLabelInterests(labels) {
    return labels.map((label) => {
      const labelInterests = allFixedRateTerms.map((fixedRateTerm) => {
        if (_.some(label.interests, interest => interest.fixedRateTermDuration === fixedRateTerm)) {
          return label.interests.find(interest => interest.fixedRateTermDuration === fixedRateTerm);
        }

        return { fixedRateTerm, initialInterest: 0, averageInterest: 0 };
      });

      return { ...label, interests: labelInterests };
    });
  }

  /* Helper method for getInterestForFrt */
  @action addNewLabelInterests(labelInterests, res) {
    return labelInterests.map((label) => {
      /* Find label with the same id */
      const newInterestObject = res.find(newLabel => newLabel.id === label.id);

      /* Then find interest with the samen frt as the newInterestObject */
      const newInterests = label.interests.map((interest) => {
        /* Loop over each frt in interests and return equal frt  */
        if (newInterestObject && newInterestObject.interests &&
          newInterestObject.interests[0].fixedRateTermDuration === interest.fixedRateTerm) {
          return newInterestObject.interests[0];
        }

        return interest;
      });
      return { ...label, interests: newInterests };
    });
  }

  @action setForm(e) {
    this.form[e.target.name] = e.target.value;
  }

  @action toggleNHG(e) {
    this.form.nhg = e.target.checked ? 1 : 0;
  }

  @action setBaseFormData() {
    const {
      mortgage,
      personalDeposit,
      nhg,
    } = this.form;

    let baseObject = {};

    if (mortgage && nhg !== undefined) {
      const maxMortgageValue = (mortgage - personalDeposit) * this.chfLtv.chfLtv;

      baseObject = {
        nhg,
        mortgage: Math.round(Number(maxMortgageValue)),
        houseValue: Math.round(Number(maxMortgageValue)),
        mortgageType: '6',
      };
    }

    if (baseObject.mortgage > 0) {
      setItemLocalStorage(baseObject, 'LooptijdRenteBaseFormData');
    }

    return baseObject;
  }

  @action validateForm() {
    const {
      mortgage,
    } = this.form;

    setItemLocalStorage(this.form, 'LooptijdRenteForm');

    let validated = true;

    ValidationData.clearResponseErrors();

    /* Validate calculationform specific conditions. */
    if (mortgage < 5000) {
      validated = false;
      /* Error messages and show alert */
      ValidationData.setErrorMessageAndFields(
        ['Vraagprijs dient hoger te zijn dan € 5.000 ,-'],
        'Er is een fout met een van de volgende velden:',
      );
    }

    return validated;
  }

}

const CalculationFormData = new CalculationFormStore();

export default CalculationFormData;
